<script setup lang="ts">
  withDefaults(
    defineProps<{
      message: string
    }>(),
    {
      message: 'Cargando...',
    }
  )
</script>
<template>
  <div
    class="absolute top-0 h-full w-full flex flex-column justify-content-center align-items-center surface-300 opacity-70"
    style="z-index: 99999"
  >
    <i
      class="pi pi-spin pi-spinner text-primary"
      style="font-size: 3rem; width: 50px"
    ></i>
    <p class="text-400 font-italic font-semibold text-primary">
      {{ message }}
    </p>
  </div>
</template>
<style></style>
